module.exports = __webpack_public_path__ + "img/4-1.8aa02117.png";